var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.004 35.292V23.99a3.008 3.008 0 0 1 3.008-3.008h10.639l-.835 4.334c0 1.5 1.809 2.256 2.874 1.197l3.019-3.019 5.821-5.821c.329-.335.5-.763.5-1.197a1.7 1.7 0 0 0-.5-1.19l-5.821-5.821-3.019-3.018c-1.065-1.059-2.874-.303-2.874 1.197l.835 4.334H18.428A8.428 8.428 0 0 0 10 20.406V35.48a4.503 4.503 0 0 0 4.64 4.5c2.464-.074 4.364-2.223 4.364-4.688zM44.996 28.708V40.01a3.008 3.008 0 0 1-3.008 3.008H31.349l.835-4.334c0-1.5-1.809-2.256-2.874-1.197l-3.019 3.019-5.821 5.821c-.329.335-.5.763-.5 1.197 0 .428.171.855.5 1.19l5.821 5.821 3.019 3.019c1.065 1.059 2.874.303 2.874-1.197l-.835-4.334h14.224a8.428 8.428 0 0 0 8.428-8.428V28.521a4.503 4.503 0 0 0-4.64-4.5c-2.465.073-4.365 2.222-4.365 4.687z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.80629de31ec0a66419f6ac86a95da6df.svg";
export { ForwardRef as ReactComponent };